import React from 'react';
import { FaStickyNote } from 'react-icons/fa';

const ItineraryNotes = ({ notesRef, notes }) => (
  <div ref={notesRef} id="notes-section" className="notes-section">
    <h2><FaStickyNote /> Important Notes</h2>
    <ul className="notes-list">
      {notes.map((note, index) => (
        <li key={index}><FaStickyNote /> {note}</li>
      ))}
    </ul>
  </div>
);

export default ItineraryNotes;
